import * as actionTypes from "../constants/actionTypes";
import * as windowService from "../services/windowService";
import * as methods from "../constants/methods";
import * as config from "../constants/config";
import * as handlers from "../constants/handlers";

export const serverConnect = (url) => ({
    type: actionTypes.SERVER_CONNECT,
    payload: {
        url: url
    }
});

export const serverDisconnect = () => ({
    type: actionTypes.SERVER_DISCONNECT
});

export const websocketConnecting = () => {
    windowService.logInfo("Connecting to server websocket.");

    return {
        type: actionTypes.WEBSOCKET_CONNECTING
    };
};

export const getAllRedlikeServers = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_AVAILABLE_SERVERS,
        params: {
            compatibleOnly: false,
            activeOnly: false
        }
    },
    method: handlers.GET_SERVER_MANAGEMENT_LIST,
    tabId: 0
});

export const websocketOpened = () => {
    windowService.logInfo("Server websocket opened.");

    return {
        type: actionTypes.WEBSOCKET_OPENED
    };
};

export const websocketClosed = (event) => {
    windowService.logInfo(
        event.reason !== "" ? "Server websocket closed: " + event.reason : "Server websocket closed."
    );

    return {
        type: actionTypes.WEBSOCKET_CLOSED
    };
};

export const websocketResponse = (event) => {
    return {
        type: actionTypes.WEBSOCKET_RESPONSE,
        payload: {
            data: event.data
        }
    };
};

export const saveWebsocketRequest = (sequence, tabId, method, next) => ({
    type: actionTypes.SAVE_WEBSOCKET_REQUEST,
    payload: {
        sequence: sequence,
        tabId: tabId,
        method: method,
        next: next
    }
});

export const websocketRequest = (payload) => ({
    type: actionTypes.WEBSOCKET_REQUEST,
    payload: payload
});

export const processWebsocketRequest = (tabId, payload, method, next = null) => {
    return (dispatch, getState) => {
        let sequence = getState().server.sequence + 1;
        dispatch(saveWebsocketRequest(sequence, tabId, method, next));

        payload.sequence = sequence;

        return dispatch(websocketRequest(payload));
    };
};

export const connectDefaultServer = () => ({
    type: actionTypes.CONNECT_DEFAULT_SERVER
});

export const setActiveServer = (server) => ({
    type: actionTypes.SET_ACTIVE_SERVER,
    payload: {
        server: server
    }
});

export const saveMulticastServerList = (servers) => ({
    type: actionTypes.SAVE_MULTICAST_SERVER_LIST,
    payload: {
        servers: servers
    }
});

export const closeServerConnection = () => ({
    type: actionTypes.CLOSE_SERVER_CONNECTION,
    payload: {
        sequence: config.SERVER_DISCONNECT_SEQUENCE
    }
});

export const serverDiscover = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_DISCOVER_SERVERS,
        params: {
            clients: []
        }
    },
    method: handlers.GET_SERVER_MANAGEMENT_LIST,
    tabId: 0
});

export const addServer = (server) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_ADD_SERVER,
        params: {
            name: server.name,
            host: server.ip,
            note: server.note,
            port: server.port
        }
    },
    method: handlers.ADD_SERVER,
    tabId: 0
});

export const editServer = (id, name, note, enabled) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_EDIT_SERVER,
        params: {
            id: id,
            name: name,
            note: note,
            enabled: enabled
        }
    },
    method: handlers.EDIT_SERVER,
    tabId: 0
});

export const setActiveServerByUrl = (url) => ({
    type: actionTypes.SET_ACTIVE_SERVER_BY_URL,
    payload: {
        url: url
    }
});

export const updateDatabases = () => ({
    type: actionTypes.START_DATABASE_UPDATE
});

export const installDatabaseExcel = (path, productFilesPath, productImagesPath, analyzeOnly, overwriteLocalData) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_INSTALL_DATABASE_FILE_EXCEL,
        params: {
            path,
            productFilesPath,
            productImagesPath,
            analyzeOnly,
            overwriteLocalData
        }
    },
    method: handlers.INSTALL_DATABASE_FILE_EXCEL,
    tabId: 0
});

export const installDatabaseExe = (path) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_INSTALL_DATABASE_FILE_EXE,
        params: {
            path: path
        }
    },
    method: handlers.INSTALL_DATABASE_FILE_EXE,
    tabId: 0
});

export const installDatabaseZip = (path) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_INSTALL_DATABASE_FILE_ZIP,
        params: {
            path: path
        }
    },
    method: handlers.INSTALL_DATABASE_FILE_ZIP,
    tabId: 0
});

export const dropServers = () => ({
    type: actionTypes.DROP_SERVERS
});

export const getAllDatabaseListAndSkipUpdate = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_DATABASES_LIST,
        params: {
            all: true
        }
    },
    method: handlers.GET_ALL_DATABASES_LIST_AND_SKIP_UPDATE,
    tabId: 0
});

export const getSupportedDataFormats = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_SUPPORTED_IMPORT_CUSTOM_DATA_FORMATS
    },
    method: handlers.SUPPORTED_IMPORT_CUSTOM_DATA_FORMATS,
    tabId: 0
});

export const setDatabase = (database) => {
    windowService.setDefaultDatabase(database);

    return {
        type: actionTypes.SERVER_REQUEST,
        payload: {
            type: methods.METHOD_SET_ACTIVE_DATABASE,
            params: {
                name: database,
                autologin: true
            }
        },
        method: handlers.SET_ACTIVE_DATABASE,
        tabId: 0,
        next: {
            type: actionTypes.SERVER_REQUEST,
            payload: {
                type: methods.METHOD_SET_ACTIVE_DATABASE,
                params: {
                    name: database,
                    autologin: false
                }
            },
            method: handlers.SET_ACTIVE_DATABASE,
            tabId: 0
        }
    };
};

export const deleteImportedRecords = () => ({
    type: actionTypes.DELETE_ALL_IMPORTED_RECORDS
});
